import React from 'react';

export default class SinPermiso extends React.Component {
    render() {
        return (<h4 style={{ margin: "0", position: "absolute", top: "50%", left: "50%", transform: "translateY(-50%) translate(-50%)", textAlign: "center" }}> No tiene permisos para realizar esta acción</h4 >);
    }
}
